import InfoIcon from "components/shared/iconInfo";
import { driverSalaryMileageTypes } from "helpers/enums";
import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { namesList as drivers } from "sources/books/drivers";

const config = {
    period: {},
    baseSalary: {
        label: "Фиксированный оклад, руб",
        inputProps: { name: "baseSalary", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
        validators: [requiredField],
        required: true,
    },
    mileageType: {
        label: (
            <>
                Тип пробега&nbsp;
                <InfoIcon
                    text={
                        <ul className="pl-3">
                            <li>
                                Плановый - умножает плановый пробег водителя по заявкам на значение в поле {`"Ставка"`}
                            </li>
                            <li>
                                Фактический - умножает фактический пробег водителя по заявкам на значение в поле{" "}
                                {`"Ставка"`}. Учитывает фактический порожний пробег
                            </li>
                            <li>
                                Фактический активный/фактический порожний - для расчета раздельно умножаются показатели
                                фактического пробега с фактическим порожним порожним пробегом из полей {`"Ставка"`} и{" "}
                                {`"Вспомогательная ставка"`}. Фактический пробег умножается на значение в поле
                                {`"Ставка"`}, порожний на значение в поле {`"Вспомогательная ставка"`}.
                            </li>
                        </ul>
                    }
                />
            </>
        ),
        inputProps: { name: "mileageType" },
        options: driverSalaryMileageTypes,
        validators: [requiredField],
        required: true,
    },
    rate: {
        label: "Ставка, руб/км",
        inputProps: { name: "rate", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
        validators: [requiredField],
        required: true,
    },
    secondaryRate: {
        label: "Вспомогательная ставка, руб/км",
        inputProps: { name: "secondaryRate", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
    },
    lowMileageMultiplier: {
        label: (
            <>
                Повышающий коэффициент за маленький пробег, %&nbsp;
                <InfoIcon
                    text={`Увеличивает базовую ставку на указанное значение, если за день работы водитель проехал меньше пробега указанного в строке "Ставка"`}
                />
            </>
        ),
        inputProps: { name: "lowMileageMultiplier", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
    },
    lowMileageThreshold: {
        label: (
            <>
                Граница определения маленького пробега&nbsp;
                <InfoIcon
                    text={`Дневной пробег водителя при котором ставка будет увеличена на значение из параметра "Повышающий коэффициент за маленький пробег"`}
                />
            </>
        ),
        inputProps: { name: "lowMileageThreshold", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
    },
    dailyIncome: {
        label: (
            <>
                Время в рейсе, руб/сутки&nbsp;
                <InfoIcon
                    text={`Фиксированная оплата за рабочий день, сумма которого добавляется, если у водителя был пробег`}
                />
            </>
        ),
        inputProps: { name: "dailyIncome", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
    },
    travelDailyIncome: {
        label: (
            <>
                Командировочные, руб/сутки&nbsp;
                <InfoIcon
                    text={`Фиксированная оплата за рабочий день, сумма которого добавляется, если у водителя был пробег`}
                />
            </>
        ),
        inputProps: { name: "travelDailyIncome", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
    },
    interBidsIdleCost: {
        label: (
            <>
                Простои между рейсами, руб/час&nbsp;
                <InfoIcon text={`Прибавляется за каждый час простоя водителя между заявками`} />
            </>
        ),
        inputProps: { name: "interBidsIdleCost", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
    },
    loadIdleCost: {
        label: (
            <>
                Простои на загрузках, руб/час&nbsp;
                <InfoIcon
                    text={`В расчёт стоимости учитываются остановки которые превышают плановый промежуток простоя на точке`}
                />
            </>
        ),
        inputProps: { name: "loadIdleCost", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
    },
    unloadIdleCost: {
        label: (
            <>
                Простои на выгрузках, руб/час&nbsp;
                <InfoIcon
                    text={`В расчёт стоимости учитываются остановки которые превышают плановый промежуток простоя на точке`}
                />
            </>
        ),
        inputProps: { name: "unloadIdleCost", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
    },
    // Надбавки за растентовки
    detarpingPrizes: {
        label: (
            <>
                Надбавки за растентовки&nbsp;
                <InfoIcon
                    text={`Прибавляется значение за каждый тип растентовки который указывается в заявках в поля "Тип погрузки" и "Тип выгрузки"`}
                />
            </>
        ),
        value: [],
        config: {
            loadUnloadTypeId: {
                label: "Тип растентовки",
                inputProps: { name: "loadUnloadTypeId" },
                menuPortalTarget: document.body,
                validators: [requiredField],
                required: true,
                value: [],
            },
            prize: {
                label: "Надбавка, руб/шт.",
                inputProps: { name: "prize", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
                validators: [requiredField],
                required: true,
            },
        },
    },
    // Персональные премии
    individualPrizes: {
        label: (
            <>
                Персональные премии&nbsp;
                <InfoIcon
                    text={`Справочник в который можно добавить произвольное значение для дальнейшего указания его конкретным водителям`}
                />
            </>
        ),
        value: [],
        config: {
            id: {},
            name: {},
        },
    },
    // Персональные премии водителей (те что выше, но уже с првязкой к конкретному водителю)
    driverIndividualPrizes: {
        label: (
            <>
                Персональные премии водителей&nbsp;
                <InfoIcon
                    text={`Указывается значение из справочника который создаётся через поле "Персональные премии". Даёт возможность указания для отдельных водителей премии с персональной суммой`}
                />
            </>
        ),
        value: [],
        config: {
            driverId: {
                label: "Водитель",
                inputProps: { name: "driverId" },
                url: drivers,
                filterPropName: "fullName",
                propName: "fullName",
                menuPortalTarget: document.body,
                validators: [requiredField],
                required: true,
            },
            // id премии из списка "prizes", выше
            individualPrizeId: {
                label: "Премия",
                inputProps: { name: "individualPrizeId" },
                validators: [requiredField],
                required: true,
            },
            prize: {
                label: "Размер премии, руб",
                inputProps: { name: "prize", type: "number", pattern: "[0-9]+([.,][0-9]+)?" },
                validators: [requiredField],
                required: true,
            },
        },
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
